// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * ActiveProgram from OPC UA LADS ActiveProgramType (i=1040).
 * Provides context about the currently active program on a FunctionalUnit.
 * @export
 * @interface UALADSActiveProgram
 */
export interface UALADSActiveProgram {
    /**
     * Name of the currently executed program template.
     */
    currentProgramTemplate: string | null;
    /**
     * Current run-time in milliseconds (excludes paused time).
     */
    currentRuntime: number | null;
    /**
     * Name of the current step.
     */
    currentStepName: string | null;
    /**
     * Index of the current step (1-based).
     */
    currentStepNumber: number | null;
    /**
     * Runtime of the current step in milliseconds.
     */
    currentStepRuntime: number | null;
    /**
     * Estimated total run-time in milliseconds.
     */
    estimatedRuntime: number | null;
    /**
     * Estimated total number of steps.
     */
    estimatedStepNumbers: number | null;
    /**
     * Estimated runtime of the current step in milliseconds.
     */
    estimatedStepRuntime: number | null;
    /**
     * Accumulated pause time in milliseconds.
     */
    currentPauseTime: number | null;
    /**
     * Device-specific unique identifier for this program run.
     */
    deviceProgramRunId: string | null;
}

/**
 * Check if a given object implements the UALADSActiveProgram interface.
 */
export function instanceOfUALADSActiveProgram(value: object): value is UALADSActiveProgram {
    if (!('currentProgramTemplate' in value) || value['currentProgramTemplate'] === undefined) return false;
    if (!('currentRuntime' in value) || value['currentRuntime'] === undefined) return false;
    if (!('currentStepName' in value) || value['currentStepName'] === undefined) return false;
    if (!('currentStepNumber' in value) || value['currentStepNumber'] === undefined) return false;
    if (!('currentStepRuntime' in value) || value['currentStepRuntime'] === undefined) return false;
    if (!('estimatedRuntime' in value) || value['estimatedRuntime'] === undefined) return false;
    if (!('estimatedStepNumbers' in value) || value['estimatedStepNumbers'] === undefined) return false;
    if (!('estimatedStepRuntime' in value) || value['estimatedStepRuntime'] === undefined) return false;
    if (!('currentPauseTime' in value) || value['currentPauseTime'] === undefined) return false;
    if (!('deviceProgramRunId' in value) || value['deviceProgramRunId'] === undefined) return false;
    return true;
}

export function UALADSActiveProgramFromJSON(json: any): UALADSActiveProgram {
    return UALADSActiveProgramFromJSONTyped(json, false);
}

export function UALADSActiveProgramFromJSONTyped(json: any, ignoreDiscriminator: boolean): UALADSActiveProgram {
    if (json == null) {
        return json;
    }
    return {
        
        'currentProgramTemplate': json['currentProgramTemplate'],
        'currentRuntime': json['currentRuntime'],
        'currentStepName': json['currentStepName'],
        'currentStepNumber': json['currentStepNumber'],
        'currentStepRuntime': json['currentStepRuntime'],
        'estimatedRuntime': json['estimatedRuntime'],
        'estimatedStepNumbers': json['estimatedStepNumbers'],
        'estimatedStepRuntime': json['estimatedStepRuntime'],
        'currentPauseTime': json['currentPauseTime'],
        'deviceProgramRunId': json['deviceProgramRunId'],
    };
}

export function UALADSActiveProgramToJSON(json: any): UALADSActiveProgram {
    return UALADSActiveProgramToJSONTyped(json, false);
}

export function UALADSActiveProgramToJSONTyped(value?: UALADSActiveProgram | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentProgramTemplate': value['currentProgramTemplate'],
        'currentRuntime': value['currentRuntime'],
        'currentStepName': value['currentStepName'],
        'currentStepNumber': value['currentStepNumber'],
        'currentStepRuntime': value['currentStepRuntime'],
        'estimatedRuntime': value['estimatedRuntime'],
        'estimatedStepNumbers': value['estimatedStepNumbers'],
        'estimatedStepRuntime': value['estimatedStepRuntime'],
        'currentPauseTime': value['currentPauseTime'],
        'deviceProgramRunId': value['deviceProgramRunId'],
    };
}

